import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { BaseService } from '../../../shared/services/base.service';
import { SummaryCreditModel } from '../models/summary-credit.model';



@Injectable()
export class CreditService extends BaseService<SummaryCreditModel,SummaryCreditModel> {
  constructor(http: HttpClient) {
    super(http, '/api/v2/credits');
  }

}
